/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
(function () {
  var isIe = /(trident|msie)/i.test(navigator.userAgent);

  if (isIe && document.getElementById && window.addEventListener) {
    window.addEventListener(
      'hashchange',
      function () {
        var id = location.hash.substring(1),
          element;

        if (!/^[A-z0-9_-]+$/.test(id)) {
          return;
        }

        element = document.getElementById(id);

        if (element) {
          if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
          }

          element.focus();
        }
      },
      false
    );
  }
})();

(function ($) {
  new WOW().init();

  $('.accordion').accordion({
    transitionSpeed: 400,
  });

  $('.toggle_overlay').on('click', function (e) {
    e.preventDefault();
    $('#contact-overlay').fadeToggle(0);
    $('#contact-overlay').addClass('animated slideInLeft');
  });

  $('.toggle_overlay').click(function (e) {
    e.preventDefault();
    if ($('#apexchat_invitation_container_wrapper')[0]) {
      $('#apexchat_invitation_container_wrapper').toggleClass('none');
    }

    if ($('#apexchat_static_tab_text')[0]) {
      $('#apexchat_static_tab_text').toggleClass('none');
    }

    if ($('#apexchat_static_button')[0]) {
      $('#apexchat_static_button').toggleClass('none');
    }
  });
})(jQuery);

/* Smooth headers on mobile & desktop */
jQuery(function ($) {
  $(window).scroll(function (e) {
    var s = $(window).scrollTop();
    if (s > 500) {
      var i = window.innerWidth,
        h = $('.desktop_header_wrap').height();
      i < 990 && (h = $('#mobile_buttons_wrap').height());
      $('header.site-header').css({ 'min-height': h }).addClass('has-sticky');
    } else 0 == s && $('header.site-header').css({ 'min-height': 'unset' }).removeClass('has-sticky');
  });
});

(function ($) {
  function new_map($el) {
    // var
    var $markers = $el.find('.marker');

    // vars
    var args = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    // create map
    var map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
      add_marker($(this), map);
    });

    // center map
    center_map(map);

    // return
    return map;
  }

  function add_marker($marker, map) {
    // var
    var latlng = new google.maps.LatLng(
      $marker.attr('data-lat'),
      $marker.attr('data-lng')
    );

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );

      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }
  }

  var map = null;

  $(document).ready(function () {
    $('.acf-map').each(function () {
      // create map
      map = new_map($(this));
    });
  });
})(jQuery);

jQuery(document).ready(function () {
  jQuery('.related-posts-togg').on('click', function () {
    jQuery(this).siblings('.related-posts-cont').slideToggle();
  });

  jQuery('#process-viewer').html(
    jQuery('.process-step .step-content').first().html()
  );
  jQuery('.process-step').click(function () {
    jQuery('.process-step').removeClass('active-prog');
    jQuery(this).addClass('active-prog');
    jQuery('#process-viewer').html(jQuery(this).find('.step-content').html());
    if (jQuery(window).width() <= 768) {
      jQuery('html, body').animate(
        {
          scrollTop: jQuery('#process-viewer').offset().top,
        },
        400
      );
    }
  });

  jQuery('.home-accordion h3').each(function () {
    jQuery(this).on('click', function () {
      var open = false;
      if (jQuery(this).next('div').css('display') !== 'none') {
        open = true;
      }
      jQuery('.home-accordion h3').removeClass('open');
      jQuery('.home-accordion > div').slideUp();
      if (!open) {
        jQuery(this).addClass('open');
        jQuery(this).next('div').slideDown();
      }
    });
  });
});

const btn1 = document.getElementById('mobile-button');

btn1.addEventListener('click', function () {
  btn1.classList.toggle('cross'),
    jQuery('.mobile_navigation').slideToggle(),
    jQuery('html').toggleClass('noscroll');
});

document.addEventListener('DOMContentLoaded', function () {
  var mobileMenu = document.querySelector('.mobile_navigation');
  var subMenus = mobileMenu.querySelectorAll('.menu-item-has-children');

  subMenus.forEach(function (menuItem) {
    menuItem.classList.remove('sub-menu-open'); // Initially close all submenus

    menuItem.addEventListener('click', function (event) {
      // event.preventDefault(); // Prevent default link behavior
      event.stopPropagation(); // Stop the event from propagating to parent elements
      var subMenu = menuItem.querySelector('.sub-menu');

      // Close all submenus except the clicked one
      subMenus.forEach(function (item) {
        if (item !== menuItem && !item.contains(menuItem)) {
          item.querySelector('.sub-menu').classList.remove('xmenu-show');
          item.querySelector('.sub-menu').classList.add('xmenu-hide');
          item.classList.remove('sub-menu-open');
        }
      });

      // Toggle the visibility of the clicked submenu
      if (subMenu.classList.contains('xmenu-show')) {
        subMenu.classList.remove('xmenu-show');
        subMenu.classList.add('xmenu-hide');
        menuItem.classList.remove('sub-menu-open');
      } else {
        subMenu.classList.remove('xmenu-hide');
        subMenu.classList.add('xmenu-show');
        menuItem.classList.add('sub-menu-open');
      }
    });
  });
});

/* Javascript for Youtube Videos to show up in a modal */
var html = document.querySelector('html');
var videoModalWrap = document.getElementById('videoModalWrap');
var closeButton = document.getElementById('modalBG-closeout');

function openThisVideo(e) {
  e.preventDefault();
  videoModalWrap.classList.toggle('triggerEffect');
  html.classList.toggle('noscroll');
}

closeButton.addEventListener('click', function (e) {
  // on close, reset classes and set iframe src to nothing
  e.preventDefault();
  videoModalWrap.classList.toggle('triggerEffect');
  html.classList.toggle('noscroll');
  var targetVideoiFrame = document.getElementById('targetVideoiFrame');
  targetVideoiFrame.src = '';
});

function showThisVid(id) {
  var targetVideoFrame = document.getElementById('video_wrap');

  // Replace the youtube ID in the embed code with the link's ID
  targetVideoFrame.innerHTML = `<iframe id="targetVideoiFrame" src="https://www.youtube.com/embed/${id}?modestbranding=1&rel=0" frameborder="0" allowfullscreen></iframe>`;

  // Add the class "triggerEffect" to the div #videoModalWrap
  var videoModalWrap = document.getElementById('videoModalWrap');
  videoModalWrap.classList.add('triggerEffect');
  html.classList.toggle('noscroll');
}
